
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[id]",
      function () {
        return require("private-next-pages/blog/[id].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/[id]"])
      });
    }
  